import { render, staticRenderFns } from "./huzhuGx.vue?vue&type=template&id=abab9382&scoped=true"
import script from "./huzhuGx.vue?vue&type=script&lang=js"
export * from "./huzhuGx.vue?vue&type=script&lang=js"
import style0 from "./huzhuGx.vue?vue&type=style&index=0&id=abab9382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abab9382",
  null
  
)

export default component.exports